export const ADD_AWARD = 'ADD_AWARD';
export const DELETE_AWARD = 'DELETE_AWARD';
